/**
 * Fetches a property from an object by path
 *
 * @param obj - object to be searched
 * @param path - path to extract (ex. 'settings.communication.enabled')
 * @return  property to be returned
 */ export default function(obj, path, defaultValue) {
    var pathParts = path.split(".");
    try {
        return pathParts.reduce(function(acc, v) {
            return acc[v];
        }, obj);
    } catch (err) {
        return defaultValue;
    }
};
